import { createRoot } from 'react-dom/client';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { HowItWorks } from './components/HowItWorks';
import { DeparturesBoard } from './components/DeparturesBoard';
import { Connect } from './components/Connect';
import { Prompts } from './components/Prompts';
import { Trust } from './components/Trust';
import { Footer } from './components/Footer';
import { useReveal } from './hooks/useReveal';
import { WidgetErrorBoundary } from '../components/WidgetErrorBoundary';
import '../index.css';
import './homepage.css';

function HomePage() {
    useReveal();

    return (
        <div className="tkh">
            <Header />
            <main id="main-content">
                <Hero />
                <StatsStrip />
                <HowItWorks />
                <DeparturesBoard />
                <Connect />
                <Prompts />
                <Trust />
            </main>
            <Footer />
        </div>
    );
}

const rootElement = document.getElementById('homepage-next-root');
if (rootElement) {
    document.title = 'Turkish Airlines MCP Server';
    createRoot(rootElement).render(
        <WidgetErrorBoundary>
            <HomePage />
        </WidgetErrorBoundary>
    );
}
